import PublicService from 'src/services/PublicService'
import SegmentService from 'src/services/SegmentService'
import CountryService from 'src/services/CountryService'
import SettingsService from 'src/services/SettingsService'
import currencies from 'src/services/currencies';
import PaymentTypeService from 'src/services/PaymentTypeService'
import TimezoneService from 'src/services/TimezoneService'
import i18n from 'src/i18n'
import { changeLanguage } from 'src/i18n';
import get from 'lodash/get'
// TODO get this from api later on
const apiKeys = {
  googleMaps: process.env.VUE_APP_GMAPS_KEY
}
let defaultTextLanguage = localStorage.getItem('app_locale') || 'en'
const types = {
  SET_SETTINGS: 'SET_SETTINGS',
  SET_JOB_BOARDS: 'SET_JOB_BOARDS',
  SET_PRODUCTS: 'SET_PRODUCTS',
  SET_COUNTRIES: 'SET_COUNTRIES',
  SET_SEGMENTS: 'SET_SEGMENTS',
  SET_SEGMENT_GROUPS: 'SET_SEGMENT_GROUPS',
  SET_CURRENCY: 'SET_CURRENCY',
  SET_TEXT_LANGUAGE: 'SET_TEXT_LANGUAGE',
  SET_APP_SETTINGS: 'SET_APP_SETTINGS',
  SET_PAYMENT_TYPES: 'SET_PAYMENT_TYPES',
  SET_TIMEZONES: 'SET_TIMEZONES',
  SET_API_KEYS: 'SET_API_KEYS'
};
const state = {
  settings: {},
  jobBoards: {},
  products: {},
  segments: {},
  segmentGroups: [],
  countries: [],
  currencySymbol: '€',
  currencyInfo: {},
  extraSettings: [],
  creditPrice: 0,
  paymentTypes: [],
  timezones: [],
  apiKeys: {},
  textLanguage: defaultTextLanguage
};

const mutations = {
  [types.SET_SETTINGS]: (state, value) => {
    state.settings = value;
    if(value.app_locale) {
      localStorage.setItem('app_locale', value.app_locale);
    }
    if(value.app_credit_price) {
      state.creditPrice = parseFloat(value.app_credit_price);
    }
  },
  [types.SET_TEXT_LANGUAGE]: (state, value) => {
    state.textLanguage = value
  },
  [types.SET_APP_SETTINGS]: (state, value) => {
    state.extraSettings = value;
  },
  [types.SET_SEGMENTS]: (state, value) => {
    state.segments = value;
  },
  [types.SET_SEGMENT_GROUPS]: (state, value) => {
    state.segmentGroups = value;
  },
  [types.SET_PRODUCTS]: (state, value) => {
    state.products = value;
  },
  [types.SET_PAYMENT_TYPES]: (state, value) => {
    state.paymentTypes = value;
  },
  [types.SET_TIMEZONES]: (state, value) => {
    state.timezones = value;
  },
  [types.SET_JOB_BOARDS]: (state, value) => {
    state.jobBoards = value;
  },
  [types.SET_COUNTRIES]: (state, value) => {
    state.countries = value;
  },
  [types.SET_API_KEYS]: (state, value) => {
    state.apiKeys = value;
  },
  [types.SET_CURRENCY]: (state, value) => {
    let currency = value.find(v => v.key === 'app_currency');
    let currencyInfo = currencies.find(c => c.code === currency.value);
    if (currencyInfo) {
      state.currencyInfo = currencyInfo;
      state.currencySymbol = currencyInfo.symbol;
      localStorage.setItem('app_currency', currencyInfo.code);
    }
  }
};

const actions = {
  async getConfig( {commit, rootState} ){
    try {
      await PublicService.updateApiHost()
    } catch (e) {
      console.warn(e)
    }
    try {
      if (localStorage.getItem('no-api-host') && process.env.VUE_APP_ENV === 'production') {
        return
      }
      let data = await PublicService.getConfig();
      if(rootState.user.isLoggedIn) {
        let countryData = await CountryService.get();
        commit(types.SET_COUNTRIES, countryData.data);
      }
      let {settings, products, segments, job_boards} = data;
      if (settings.app_locale && settings.app_locale !== i18n.locale) {
        await changeLanguage(settings.app_locale)
      }
      commit(types.SET_SETTINGS, settings);
      commit(types.SET_SEGMENTS, segments);
      commit(types.SET_PRODUCTS, products);
      commit(types.SET_JOB_BOARDS, job_boards);
      commit(types.SET_API_KEYS, apiKeys);
      if (rootState.user.isLoggedIn) {
        let segmentGroups = await SegmentService.getSegmentGroups()
        commit(types.SET_SEGMENT_GROUPS, segmentGroups.data)
      }
      return data;
    } catch (e) {
      throw e;
    }
  },
  async getAppSettings( {commit, getters}) {
    let {data} = await SettingsService.get({limit: 200});
    commit(types.SET_APP_SETTINGS, data)
    commit(types.SET_CURRENCY, data)

    if (getters.getAppSetting('app_date_format')) {
      localStorage.setItem('app_date_format', getters.getAppSetting('app_date_format'));
    }
    if (getters.getAppSetting('app_hour_format')) {
      localStorage.setItem('app_hour_format', getters.getAppSetting('app_hour_format'));
    }
  },
  async getPaymentTypes( { commit }) {
    let {data} = await PaymentTypeService.get({limit: 200});
    commit(types.SET_PAYMENT_TYPES, data)
  },
  async getTimezones( {commit}) {
    let {data} = await TimezoneService.get();
    commit(types.SET_TIMEZONES, data)
  }
};
const getters = {
  allProducts: state => {
    let products = state.products
    let productsArray = []
    for(let key in products) {
      products[key].forEach(product => {
        productsArray.push({
          ...product,
          product_type: key
        })
      })
    }
    return productsArray
  },
  jobPostingProducts: state => get(state, 'products.job_posting', []),
  jobUpgradeProducts: state => get(state, 'products.job_up_sell', []),
  creditProducts: state => {
    let creditProducts = get(state, 'products.credit', [])
    return parseProducts(creditProducts)
  },
  contractProducts: state => {
    let contractProducts = get(state, 'products.contract', [])
    return parseProducts(contractProducts)
  },
  getJobBoardById: state => id => {
    if (!id) {
      return null
    }
    let idString = id.toString();
    return state.jobBoards.find(j => j.id.toString() === idString);
  },
  allSegments: state => {
    let allSegments = []
    for(let key in state.segments) {
      allSegments.push(...state.segments[key])
    }
    return allSegments
  },
  getSegmentById: (state, getters) => id => {
    return getters.allSegments.find(s => s.id === id) || {}
  },
  getSegmentGroupBySlug: state => slug => {
    return state.segmentGroups.find(s => s.slug === slug) || {}
  },
  getSetting: state => name => {
    if (!Array.isArray(state.settings)) {
      return null
    }
    let setting = state.settings.find(s => s.key === name)
    if (setting) {
      return setting.value
    }
    return null
  },
  getAppSetting: state => name => {
    let setting = state.extraSettings.find(s => s.key === name)
    if (setting) {
      return setting.value
    }
    return null
  },
  distanceSymbol: (state, getters) => {
    const useImperial = getters.getAppSetting('app_use_imperial_system')
    return useImperial && useImperial !== '0' ? 'miles': 'km'
  },
  getPaymentType: state => id => {
    let paymentTypes = state.paymentTypes || []
    let type = paymentTypes.find(p => p.id === id);
    if(!type) {
      return {}
    };
    return type;
  },
  autocompleteCountries: state => {
    return state.countries.map(c => (c.code || '').toLowerCase())
  }
};

function parseProducts (products) {
  return products.sort((a, b) => {
    let numberPartA = a.name.split(' ')[0];
    let numberA = parseInt(numberPartA);

    let numberPartB = b.name.split(' ')[0];
    let numberB = parseInt(numberPartB);
    if(typeof numberA === 'number' && typeof numberB === 'number') {
      return numberA - numberB;
    }
    return a.name.toLowerCase() - b.name.toLowerCase()
  });

}

export default {
  namespaced: true,
  types,
  state,
  mutations,
  actions,
  getters
};
